export default __webpack_public_path__ + "static/media/push_pop_socket.962386ce.jpg";